import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"
import { isLoadingCommonFilters } from "@signals"
import { areCommonFiltersValid } from "@signals/commonFilters/filters"
import { filterSearchButtonProps } from "@components/@base/FilterPanel"


export default function CommonFiltersFooterActions() {
	return <ButtonLoadingSeeker
		loading={isLoadingCommonFilters.value}
		{...filterSearchButtonProps}
		onClick={() => isLoadingCommonFilters.value = true}
		disabled={!areCommonFiltersValid.value}
	>
		Search
	</ButtonLoadingSeeker>
}